export default __webpack_public_path__ + "static/Concrete-Sidewalk-Removal-dd9ccd45430871cc93de644020a30a7f.jpg";